/** @format */
'use client';
// import GlobalSearch from '@/app/[locale]/ui/GlobalSearch';
import NavLink from '@/app/[locale]/ui/NavLink';
import NotificationButton from '@/app/[locale]/ui/NotificationButton';
import UserButton from '@/app/[locale]/ui/UserButton';
import Link from '@/components/ui/client/Link';
import EnvironmentLabel from '@atoms/EnvironmentLabel';
import logo from '@common/application/assets/images/logo-cropped.png';
import { useIsAdmin } from '@common/application/hooks/useIsAdmin';
import dynamic from 'next/dynamic';
import Image from 'next/legacy/image';
import { usePathname } from 'next/navigation';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ILink } from './MobileNav';
import styles from './Nav.module.css';

const GlobalSearch = dynamic(() => import('@/app/[locale]/ui/GlobalSearch'), {
  ssr: false,
  loading: () => <div style={{ height: '38px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} />,
});

export function Nav() {
  const { isAdmin, isSuperAdmin } = useIsAdmin();
  const pathname = usePathname();
  const splitPath = pathname?.split('/');

  const links: ILink[] = [
    { href: '/', text: <FormattedMessage defaultMessage="Home" description="Home page link in the navigation bar" />, active: splitPath?.length === 2 },
    {
      href: '/admin/accounts',
      text: <FormattedMessage defaultMessage="Administration" description="Administration page link in the navigation bar" />,
      adminOnly: true,
      active: splitPath?.[2] === 'admin',
    },
    { href: '/help', text: <FormattedMessage defaultMessage="Help" description="Help page link in the navigation bar" />, active: splitPath?.[2] === 'help' },
    // { href: '/resources', text: <FormattedMessage defaultMessage="Resources" description="Resources page link in the navigation bar" />, featureFlag: 'resource' },
    // { href: '/about', text: <FormattedMessage defaultMessage="About" description="About page link in the navigation bar" />, active: splitPath?.[2] === 'about' },
  ];

  // if (width < 760) {
  //   return <MobileNav links={links} />;
  // }

  const showEnv = isSuperAdmin;

  return (
    <nav className={styles.nav}>
      <div className={styles.navGroup}>
        <div className={styles.logo}>
          <div
            style={{
              width: '64px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Link href={'/'}>
              <Image
                title={'Home'}
                style={{ cursor: 'pointer' }}
                src={logo}
                // layout={'fill'}
                width={showEnv ? 32 : 64}
                height={showEnv ? 16 : 32}
                alt="trackup"
              />
            </Link>
          </div>
          {showEnv && <EnvironmentLabel />}
        </div>
        {links.map((link) => {
          if (link.adminOnly && !isAdmin) return null;

          return (
            <NavLink href={link.href} active={link.active} key={`navLink${link.href}`}>
              {link.text}
            </NavLink>
          );
        })}
      </div>
      {/*<Skeleton height={38} />*/}
      <GlobalSearch />

      <div className={styles.navGroup}>
        <UserButton />
        <NotificationButton />
        {/*Todo - can put this back but what's the point?*/}
        {/*<Button onClick={toggle}>*/}
        {/*  <FontAwesomeIcon icon={['fas', screenSizeIcon]} />*/}
        {/*  <Text.Plain>*/}
        {/*    {fullScreen ? (*/}
        {/*      <FormattedMessage defaultMessage="Exit Fullscreen" description="Menu bar exit fullscreen button text" />*/}
        {/*    ) : (*/}
        {/*      <FormattedMessage defaultMessage="Enter Fullscreen" description="Menu bar enter fullscreen button text" />*/}
        {/*    )}*/}
        {/*  </Text.Plain>*/}
        {/*</Button>*/}
      </div>
    </nav>
  );
}
